/**
 * Whether this document is the builder running EMBEDDED in a host.
 *
 * Read from the URL, not the store: `embedded=true` is the marker every host
 * appends when it points a frame at us (see web-app's services/builderPath), and
 * it is answerable during the very first request, before hydration.
 *
 * @returns {boolean} True when framed by a host.
 */
export const isEmbeddedDocument = () => {
    try {
        return new URLSearchParams(window.location.search).get('embedded') === 'true'
    } catch (e) {
        return false
    }
}

/**
 * Whether a write from this document has to survive the document being torn down.
 *
 * SG-14449 — an embedded builder is disposable by design: the host mounts and
 * unmounts the frame as it navigates, and a save is immediately followed by the
 * host moving the user. Anything still in flight at that moment is cancelled, so
 * writes whose value is on the SERVER (a usage log, a user-config update) were
 * lost at random. `keepalive` is what tells the browser to finish them anyway.
 *
 * Only for small bodies: the browser caps all in-flight keepalive requests at
 * 64KB together and rejects beyond that, which is why this is asked for per call
 * site rather than applied to every request the frame makes.
 *
 * @returns {boolean} True when the request should outlive this document.
 */
export const shouldOutliveDocument = () => isEmbeddedDocument()
